import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const s3PresignedQuoteUrl = async (fileExtension, existingUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const type = "QuoteImage";

    const response = await axios.get(
        `${API_URL}/company/myquotes/generateUrl/${fileExtension}/${type}/${existingUuid}`,
        {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    );

    return {
        imageQuoteUrl: response.data,
        thumbnailImageUrl: response.data
    };
};

export const updateQuoteImage = async (quoteFullUrl, image) => {
    await axios.put(quoteFullUrl, image, {
        headers: { "Content-Type": image.type }
    });
};

export const s3PresignedArticleUrl = async (fileExtension, existingUuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN); 
    const type = "ArticleImage";
    const response = await axios.get(`${API_URL}/company/myquotes/generateUrl/${fileExtension}/${type}/${existingUuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });

    return response.data;
};

export const updateArticleImage = async (articleFullUrl, image) => {
    await axios.put(articleFullUrl, image, {
        headers: { "Content-Type": image.type }
    });
};
